import * as React from 'react';
// mui
import {
  Container,
  Typography,
  Box
} from '@mui/material';

export default function PageNotFound() {
  return (
    <Container maxWidth="sm">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" sx={{ mb: 2 }}>
          404 Page Not Found
        </Typography>
      </Box>
    </Container>
  );
}
